// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
var _ = require('lodash');
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { showLoader } from '../../actions/status';
import { navEnable } from '../../actions/nav';
import {
  addSubscription, createSubscription, validateCouponCode,
  handlePaymentInfoSubmission, initializePaymentInformation, rememberCardData, rebindCouponData
} from '../../actions/locationView';
import constants from '../../Constants';
import { roundOffDecimals } from '../../utils/Utility';

import FormField from 'grommet/components/FormField';
//import Form from 'grommet/components/Form';
import Button from 'grommet/components/Button';
import CheckBox from 'grommet/components/CheckBox';
import CaretBackIcon from 'grommet/components/icons/base/CaretBack';
import CloseIcon from 'grommet/components/icons/base/Close';
import Heading from 'grommet/components/Heading';
import Layer from 'grommet/components/Layer';
import Paragraph from 'grommet/components/Paragraph';
import NavControl from '../NavControl';
import {injectStripe} from 'react-stripe-elements';
import {CardNumberElement, CardExpiryElement, CardCVCElement} from 'react-stripe-elements';
import StripeCheckout from 'react-stripe-checkout';


class LocationView extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getPlaceHolder = this.getPlaceHolder.bind(this);
    this.goToSubscriptionView = this.goToSubscriptionView.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.validateCouponCode = this.validateCouponCode.bind(this);
    this.closeConfirmationDialog = this.closeConfirmationDialog.bind(this);
    this.showCouponDetails = this.showCouponDetails.bind(this);
    this.rememberCardData = this.rememberCardData.bind(this);
    this.paymentInformationSection = this.paymentInformationSection.bind(this);
    this.bindCouponData = this.bindCouponData.bind(this);


    this.state = {
      couponDetails: null,
      showConfirmationDialog: false,
      paymentInformation : null,
      showError: false,
      selectedPlan: null
    };
  }

  componentWillMount() {

  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }
  componentDidUpdate() {

  }

  componentWillUnmount() {

  }


  validateCouponCode() {
    let couponCode = this.refs.couponCode.value;
    let appliedCoupon = this.props.couponDetails;
    if(!appliedCoupon || !appliedCoupon.coupon ||
      (appliedCoupon && ((appliedCoupon.coupon.code && appliedCoupon.coupon.code !== couponCode) ||
        (appliedCoupon.coupon.id && appliedCoupon.coupon.id !== couponCode))))
    this.props.dispatch(validateCouponCode(couponCode));
  }

  handleSubmit (ev) {
    // We don't want to let default form submission happen here, which would refresh the page.
    ev.preventDefault();
    let coupon;
    const selectedPlan = this.props.selectedPlan;
    const selectedTwig = this.props.selectedTwig;
    const twigIndex = this.props.selectedTwigIndex;
    const rememberMe = this.props.rememberMe ? true : false;

    // Within the context of `Elements`, this call to createToken knows which Element to
    // tokenize, since there's only one in this group.
    const email = ev.target.elements['email'].value;
    const name = email;
    if(this.props.couponDetails && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid){
      let isTrialCoupon =  this.props.couponDetails.isTrialCoupon ? true : false;
      coupon = {
        code : ev.target.elements['coupon'].value,
        isTrialCoupon,
        details: this.props.couponDetails.coupon
      };
    }
    let tokens;
    this.props.dispatch(showLoader(true));
    // console.log(this.props);
    if((this.props.couponDetails &&
      this.props.couponDetails.coupon &&
      this.props.couponDetails.coupon.valid && this.props.couponDetails.coupon.percent_off === 100 && this.props.couponDetails.coupon.duration === "forever") /*|| this.calculateAmount() == 0*/) {
        this.props.dispatch(showLoader(false));
        this.props.dispatch(initializePaymentInformation({customerToken: null, coupon, selectedTwig, selectedPlan, rememberMe, twigIndex, email}));
        this.props.dispatch(handlePaymentInfoSubmission({showConfirmationDialog : !this.props.showConfirmationDialog, showError : false}));
    }
    else if(!this.props.savedCard) {
      this.props.stripe.createToken({name}).then(customerToken => {
        if(customerToken && !customerToken.error) {
          customerToken.email = email;
          this.props.dispatch(showLoader(false));
          this.props.dispatch(initializePaymentInformation({customerToken, coupon, selectedTwig, selectedPlan, rememberMe, twigIndex}));
          this.props.dispatch(handlePaymentInfoSubmission({showConfirmationDialog : !this.props.showConfirmationDialog, showError : false}));
        }
        else {
          this.props.dispatch(handlePaymentInfoSubmission({showError : true}));
          this.props.dispatch(showLoader(false));
        }
      });
    }
    else {
      const savedCard = this.props.savedCard;
      this.props.dispatch(showLoader(false));
      this.props.dispatch(initializePaymentInformation({coupon, selectedTwig, selectedPlan, rememberMe, savedCard, twigIndex}));
      this.props.dispatch(handlePaymentInfoSubmission({showConfirmationDialog : !this.props.showConfirmationDialog, showError : false}));
    }
  }

  getPlaceHolder(type){
    let placeholder;
    switch(type){
      case constants.STRIPE_PLACEHOLDER.CARD_NUMBER :
        placeholder = "Card Number *";
        break;
      case constants.STRIPE_PLACEHOLDER.EXPIRY :
        placeholder = "Expiry *";
        break;
      case constants.STRIPE_PLACEHOLDER.CVC :
        placeholder = "CVC *";
        break;
      default:
        placeholder = "Please enter valid data";
        break;
    }
    return placeholder;
  }

  goToSubscriptionView() {
    this.props.dispatch(addSubscription(!this.props.showSubscriptionForm));
  }

  handleConfirmation() {
    let payload = {
      showSubscriptionForm : !this.props.showSubscriptionForm,
      showStripePlans: !this.props.showStripePlans,
      paymentInformation: this.props.paymentInformation,
      selectedTwig: this.props.selectedTwig

    }
    if(this.props.paymentInformation){
      this.props.dispatch(createSubscription(payload));
    }
    this.props.dispatch(handlePaymentInfoSubmission({showConfirmationDialog : !this.props.showConfirmationDialog}));
    this.props.dispatch(navEnable(false));
  }

  getConfirmationContent() {
    let message;
    if(this.props.selectedPlan) {
      let interval_count = this.props.selectedPlan.interval_count != 1 ? `${this.props.selectedPlan.interval_count}` : ``;

      if(this.props.couponDetails && this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid){
        if(this.props.couponDetails.isTrialCoupon){
          message = `A trial period of ${this.props.couponDetails.coupon.duration} days is applied to your subscription. You will be charged $${roundOffDecimals(this.props.selectedPlan.amount/100, 2)} every ${count} ${this.props.selectedPlan.interval} for Stem ${this.props.selectedTwig.name}/${this.props.selectedTwig.twigId} starting from date ${new Date(new Date().getTime()+((30*24*60*60*1000))).toLocaleDateString()}. We will auto-renew
          subscription at the end of every ${interval_count} ${this.props.selectedPlan.interval}. Click Submit to confirm subscription`;
         }
         else{
          let discount  = this.props.couponDetails.coupon.amount_off ? `$${roundOffDecimals(this.props.couponDetails.coupon.amount_off/100, 2)}` : `${this.props.couponDetails.coupon.percent_off} %`;
          message = `A discount of ${discount} is applied to the first billing cycle of your subscription. The net amount payable for the first billing cycle of your subscription is $${this.calculateAmount()}. You will be charged $${roundOffDecimals(this.props.selectedPlan.amount/100, 2)} every ${interval_count} ${this.props.selectedPlan.interval} for Stem ${this.props.selectedTwig.name}/${this.props.selectedTwig.twigId} from the subsequent billing cycles. We will auto-renew subscription at the end of every ${interval_count} ${this.props.selectedPlan.interval}. Click Submit to confirm subscription`;
        }
      }
      else {
        message = `You will be charged $${roundOffDecimals(this.props.selectedPlan.amount/100, 2)} every ${interval_count} ${this.props.selectedPlan.interval} for Stem ${this.props.selectedTwig.name}/${this.props.selectedTwig.twigId}. We will auto-renew subscription at the end of every ${interval_count} ${this.props.selectedPlan.interval}. Click Submit to confirm subscription`;
      }
      return (<Heading strong={false}
        align='center'
        margin='small'
        tag='h3'>
          {message}
      </Heading>);
    }
  }

  closeConfirmationDialog () {
    this.props.dispatch(handlePaymentInfoSubmission(!this.props.showConfirmationDialog));
  }

  rememberCardData () {
    let coupon = '';
    if(this.refs && this.refs['couponCode'].value) {
     coupon = this.refs['couponCode'].value;
    }
    this.props.dispatch(rememberCardData(!this.props.rememberMe));
    this.props.dispatch(rebindCouponData(coupon));
  }

  bindCouponData() {
    let coupon = '';
    if(this.refs && this.refs['couponCode'].value) {
     coupon = this.refs['couponCode'].value;
    }
    this.props.dispatch(rebindCouponData(coupon));
  }

  showConfirmation () {
    return this.props.showConfirmationDialog ?
    <Layer flush={true}
    onClose={this.closeConfirmationDialog}>
      <Button icon={<CloseIcon />}
      onClick={this.closeConfirmationDialog}
      plain={true} style={{position: 'absolute', float:'right', right: '0'}}/>
        <div style={{textAlign: "center"}} className="heading confirmation-content">
          {this.getConfirmationContent()}
          <Button label='Submit'
                className='lighter-font'
                onClick={this.handleConfirmation}
                primary={true}
                secondary={false}
                accent={false} />
        </div>
    </Layer> : '';
  }

  calculateAmount() {
    if(this.props.selectedPlan.amount && this.props.couponDetails &&
          this.props.couponDetails.isTrialCoupon === false &&
          this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid) {
      if(this.props.couponDetails.coupon.amount_off){
        if(this.props.couponDetails.coupon.amount_off > this.props.selectedPlan.amount){
          return '0.00';
        }
        else {
          return roundOffDecimals((this.props.selectedPlan.amount - this.props.couponDetails.coupon.amount_off)/100, 2);
        }
      }
      else {
        return roundOffDecimals((this.props.selectedPlan.amount - (this.props.selectedPlan.amount * this.props.couponDetails.coupon.percent_off/100))/100, 2);
      }

    }
    else {
      return this.props.selectedPlan.amount/100;
    }
  }

  getContent (component){
    let content;
    let interval_count = this.props.selectedPlan && this.props.selectedPlan.interval_count != 1 ? `${this.props.selectedPlan.interval_count}` : ``;

    if(this.props.selectedPlan){
      switch (component) {
        case "formHeading":
          content = (<h3 className="heading plan-heading">Add Plan <span> {this.props.selectedPlan.name}</span> for <span> ${this.props.selectedPlan.amount/100}</span> every
            <span> {interval_count} {this.props.selectedPlan.interval}</span> to Stem <span> {this.props.selectedTwig.name}/{this.props.selectedTwig.twigId}</span>
            </h3>);
          break;
        case "submitButton":
          content = (<span>Pay ${this.calculateAmount()}</span>);
          break;
        default :
          break;
      }
    }
    return content;
  }

  showCouponDetails () {
    if(this.props.couponDetails) {
      if(this.props.couponDetails.coupon && this.props.couponDetails.coupon.valid){
        if(this.props.couponDetails.isTrialCoupon) {
          return (<div className="coupon-applied-success">
            <div>Coupon code applied.</div>
            <div className="plan-details">
              <div>Subscription cost : <span>${roundOffDecimals(this.props.selectedPlan.amount/100, 2)}</span></div>
              <div>Trial period applied : <span>{this.props.couponDetails.coupon.duration} days</span></div>
            </div>
            </div>)
        }
        else if(this.props.couponDetails.isTrialCoupon === false){
          let discount  = this.props.couponDetails.coupon.amount_off ? `$${roundOffDecimals(this.props.couponDetails.coupon.amount_off/100, 2)}` : `${this.props.couponDetails.coupon.percent_off} %`;
          return (<div className="coupon-applied-success">
              <div>Coupon code applied.</div>
              <div className="plan-details">
                <div>Subscription cost : <span>${roundOffDecimals(this.props.selectedPlan.amount/100, 2)}</span></div>
                <div>Discount applied : <span>{discount}</span></div>
                <div style={{borderTop : '1px solid #777777'}}> Total payable amount : <span>${this.calculateAmount()}</span></div>
              </div>
            </div>)
        }
      }
      else{
        return (<div className="coupon-applied-error">Invalid coupon</div>);
      }
    }
    else {
      if(this.refs && this.refs['couponCode']){
        this.refs['couponCode'].value = '';
      }
      return '';
    }
  }

  showHideValidationErrors() {
    return this.props.showError ?( <div className="error">
        Please fill all the mandatory card information
      </div>) : '';
  }

  paymentInformationSection (createOptions) {
    if(!this.props.savedCard) {
      return (<form onSubmit={this.handleSubmit}>
        <FormField>
            {this.getContent("formHeading")}
            <div className="confirm-subscription-form">
              <div className="subscription-element-container">
                  <div><input name="email" type='email' placeholder="Email *" className='input-email' required/></div>
              </div>
              <div className="subscription-element-container">
                  <label>
                      <CardNumberElement {...createOptions(constants.STRIPE_PLACEHOLDER.CARD_NUMBER)}/>
                  </label>
              </div>
              <div className="subscription-element-container">
                  <label>
                      <CardExpiryElement {...createOptions(constants.STRIPE_PLACEHOLDER.EXPIRY)}/>
                  </label>
              </div>
              <div className="subscription-element-container">
                  <label>
                      <CardCVCElement {...createOptions(constants.STRIPE_PLACEHOLDER.CVC)}/>
                  </label>
              </div>
              <div className="coupon-code-section">
                <input ref='couponCode' type='text' name="coupon" placeholder="Coupon code" className='coupon-code' value={this.props.couponData} onChange = {this.bindCouponData}/>
                <span className="apply-button-container">
                  <Button label='Add'
                    onClick ={this.validateCouponCode}
                    className='apply-button'
                    primary={true}
                    secondary={false}
                    accent={false} />
                </span>
                <CheckBox label='Remember Me' disabled={false}  checked= {this.props.rememberMe ? true: false} onChange = {this.rememberCardData}/>
                {this.showCouponDetails()}
              </div>
              <div style={{textAlign : 'center'}}>{this.showHideValidationErrors()}</div>
              <div className="submit-button-container">
                <Button label= {this.getContent("submitButton")}
                  type='submit'
                  primary={true}/>
              </div>
          </div>
        </FormField>
      </form>) ;
    }
    else {
      return (<form onSubmit={this.handleSubmit}>
        <FormField>
            {this.getContent("formHeading")}
            <div className="confirm-subscription-form">
              <div className="subscription-element-container">
                  <div><input name="email" type='email' placeholder="Email *" className='input-email' required/></div>
              </div>
              <div className="subscription-element-container">
                  <input type="text" className="rememberData-autofill-input" value={'********'+this.props.savedCard.card.last4} readOnly />
              </div>
              <div className="subscription-element-container">
                  <input type="text" className="rememberData-autofill-input" value={this.props.savedCard.card.exp_month + '/ ' + this.props.savedCard.card.exp_year} readOnly />
              </div>
              <div className="subscription-element-container">
                  <input type="text" className="rememberData-autofill-input" value="***" readOnly />
              </div>
              <div className="coupon-code-section">
                <input ref='couponCode' type='text' name="coupon" placeholder="Coupon code" className='coupon-code'/>
                <span className="apply-button-container">
                  <Button label='Apply'
                    onClick ={this.validateCouponCode}
                    className='apply-button'
                    primary={true}
                    secondary={false}
                    accent={false} />
                </span>
                <CheckBox label='Remember Me' disabled={false}  checked= {this.props.rememberMe ? true: false} onChange = {this.rememberCardData}/>
                {this.showCouponDetails()}
              </div>
              <div className="submit-button-container">
                <Button label= {this.getContent("submitButton")}
                  type='submit'
                  primary={true}/>
              </div>
          </div>
        </FormField>
      </form>) ;
    }
  }

  render() {
    const createOptions = (type) => {
      return {
        placeholder : this.getPlaceHolder(type),
        style: {
          base: {
            fontSize : '24px',
            fontStyle: 'bold',
            color: '#424770',
            letterSpacing: '0.025em',
            fontFamily: '',
            '::placeholder': {
              color: '#AAAAAA',
            },
          },
          invalid: {
            color: '#9e2146',
          },
        },
      };
    };

    return (
      <div className="checkout-section">
        <Button label='Back'
          icon={<CaretBackIcon />}
          onClick={this.goToSubscriptionView}
          plain={true} />
        <h2 className="heading">Confirm Subscription</h2>
      {this.paymentInformationSection(createOptions)}
    {this.showConfirmation()}
    </div>
    );
  }

}

LocationView.propTypes = {
  twigsList: PropTypes.array,
  search: PropTypes.object
};

let select = (state, props) => ({
  selectedTwig: state.locationView.selectedTwig,
  selectedTwigIndex : state.locationView.selectedTwigIndex,
  stripePlans: state.locationView.stripePlans,
  showSubscriptionForm : state.locationView.showSubscriptionForm,
  selectedPlan: state.locationView.selectedPlan,
  couponDetails: state.locationView.couponDetails,
  subscriptionCreated : state.locationView.subscriptionCreated,
  subscription: state.locationView.subscription,
  showConfirmationDialog: state.locationView.showConfirmationDialog,
  showError: state.locationView.showError,
  showStripePlans: state.locationView.showStripePlans,
  paymentInformation : state.locationView.paymentInformation,
  rememberMe : state.locationView.rememberMe,
  savedCard : state.locationView.savedCard,
  couponData: state.locationView.couponData
});

export default injectStripe(connect(select)(LocationView));



// WEBPACK FOOTER //
// ./src/js/components/location/ConfirmSubscription.js